let educationLevelFacilitator_en = "Please select what you’re currently teaching..";
let educationLevelLearner_en = "Please select your current education level.";
let overMinimumAge_en = "You must be over the age of 16 years.";
let facilitatorDocument_en = "Please agree to the usage of the Facilitator documents..."

let educationLevelFacilitator_de = "Bitte wählen Sie aus, was Sie gerade unterrichten.";
let educationLevelLearner_de = "Bitte wählen Sie Ihre aktuelle Bildungsstufe.";
let overMinimumAge_de = "Sie müssen über 16 Jahre alt sein.";
let facilitatorDocument_de = "Bitte stimmen Sie der Verwendung der Facilitator-Dokumente zu."

let educationLevelFacilitator_es = "Por favor, seleccione lo que está enseñando actualmente.";
let educationLevelLearner_es = "Por favor, seleccione su nivel de educación actual.";
let overMinimumAge_es = "Debe ser mayor de 16 años.";
let facilitatorDocument_es = "Por favor, acepte el uso de los documentos del Facilitador."

let educationLevelFacilitator_es_mx = "Por favor, seleccione lo que está enseñando actualmente.";
let educationLevelLearner_es_mx = "Por favor, seleccione su nivel de educación actual.";
let overMinimumAge_es_mx = "Debe ser mayor de 16 años.";
let facilitatorDocument_es_mx = "Por favor, acepte el uso de los documentos del Facilitador."

let educationLevelFacilitator_fr = "Veuillez sélectionner ce que vous enseignez actuellement.";
let educationLevelLearner_fr = "Veuillez sélectionner votre niveau d’éducation actuel.";
let overMinimumAge_fr = "Vous devez être âgé de plus de 16 ans.";
let facilitatorDocument_fr = "Veuillez accepter l’utilisation des documents du facilitateur."

let educationLevelFacilitator_it = "Seleziona ciò che stai insegnando attualmente.";
let educationLevelLearner_it = "Seleziona il tuo attuale livello di istruzione.";
let overMinimumAge_it = "Devi avere più di 16 anni.";
let facilitatorDocument_it = "Si prega di accettare l'utilizzo dei documenti del Facilitatore."

let educationLevelFacilitator_ja = "現在教えている内容を選択してください。";
let educationLevelLearner_ja = "現在の教育レベルを選択してください。";
let overMinimumAge_ja = "あなたは16歳以上でなければなりません。";
let facilitatorDocument_ja = "ファシリテーター文書の使用に同意してください。"

let educationLevelFacilitator_ko = "현재 가르치고 있는 내용을 선택하십시오.";
let educationLevelLearner_ko = "현재 교육 수준을 선택하십시오.";
let overMinimumAge_ko = "16세 이상이어야 합니다.";
let facilitatorDocument_ko = "진행자 문서의 사용에 동의하십시오."

let educationLevelFacilitator_vi = "Vui lòng chọn những gì bạn hiện đang giảng dạy.";
let educationLevelLearner_vi = "Vui lòng chọn trình độ học vấn hiện tại của bạn.";
let overMinimumAge_vi = "Bạn phải trên 16 tuổi.";
let facilitatorDocument_vi = "Vui lòng đồng ý với việc sử dụng các tài liệu của Người hướng dẫn."

let educationLevelFacilitator_zh = "请选择您当前正在教授的内容。";
let educationLevelLearner_zh = "请选择您当前的教育水平。";
let overMinimumAge_zh = "您必须年满 16 岁。";
let facilitatorDocument_zh = "请同意使用协调人文件。"

let educationLevelFacilitator_zh_HK = "请选择您当前正在教授的内容。";
let educationLevelLearner_zh_HK = "请选择您当前的教育水平。";
let overMinimumAge_zh_HK = "您必须年满 16 岁。";
let facilitatorDocument_zh_HK = "请同意使用协调人文件。"

export function messages(lang, validation) {
	switch (lang)
	{
		case 'en':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_en;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_en;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_en;
				break;
			}
			else
			{
				return facilitatorDocument_en;
				break;
			}
		case 'de':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_de;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_de;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_de;
				break;
			}
			else {
				return facilitatorDocument_de;
				break;
			}
		case 'es':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_es;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_es;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_es;
				break;
			}
			else {
				return facilitatorDocument_es;
				break;
			}
		case 'es-mx':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_es_mx;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_es_mx;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_es_mx;
				break;
			}
			else {
				return facilitatorDocument_es_mx;
				break;
			}
		case 'fr':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_fr;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_fr;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_fr;
				break;
			}
			else {
				return facilitatorDocument_fr;
				break;
			}
		case 'ja':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_ja;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_ja;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_ja;
				break;
			}
			else {
				return facilitatorDocument_ja;
				break;
			}
		case 'it':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_it;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_it;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_it;
				break;
			}
			else {
				return facilitatorDocument_it;
				break;
			}
		case 'ko':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_ko;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_ko;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_ko;
				break;
			}
			else {
				return facilitatorDocument_ko;
				break;
			}
		case 'vi':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_vi;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_vi;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_vi;
				break;
			}
			else {
				return facilitatorDocument_vi;
				break;
			}
		case 'zh':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_zh;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_zh;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_zh;
				break;
			}
			else {
				return facilitatorDocument_zh;
				break;
			}
		case 'zh_HK':
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_zh_HK;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_zh_HK;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_zh_HK;
				break;
			}
			else {
				return facilitatorDocument_zh_HK;
				break;
			}
		default:
			if (validation === 'educationLevelFacilitator') {
				return educationLevelFacilitator_en;
				break;
			}
			else if (validation === 'educationLevelLearner') {
				return educationLevelLearner_en;
				break;
			}
			else if (validation === 'overMinimumAge') {
				return overMinimumAge_en;
				break;
			}
			else {
				return facilitatorDocument_en;
				break;
			}
	}
}
